import React from "/vendor/react";
import PropTypes from "prop-types";
import gql from "/vendor/graphql-tag";
import uniqueId from "/lib/util/uniqueId";

import { NamespaceLink } from "/lib/component/util";
import { Checkbox, TableCell } from "/vendor/@material-ui/core";
import { HoverController } from "/lib/component/controller";

import {
  DeleteMenuItem,
  EditMenuItem,
} from "/lib/component/partial/ToolbarMenuItems";

import ConfirmDelete from "/lib/component/partial/ConfirmDelete";
import ResourceDetails from "/lib/component/partial/ResourceDetails";
import TableOverflowCell from "/lib/component/partial/TableOverflowCell";
import TableSelectableRow from "/lib/component/partial/TableSelectableRow";
import { FloatingTableToolbarCell } from "/lib/component/partial/TableToolbarCell";
import ToolbarMenu from "/lib/component/partial/ToolbarMenu";

import HandlersListItemDetails from "./HandlersListItemDetails";

const HandlersListItem = ({
  editable,
  editing,
  handler,
  hovered,
  onHover,
  selected,
  onChangeSelected,
  onClickEdit,
  onClickDelete,
}) => {
  const id = React.useMemo(() => `:${uniqueId()}`, []);

  return (
    <HoverController onHover={onHover}>
      <TableSelectableRow selected={selected}>
        {editable && (
          <TableCell padding="checkbox">
            <Checkbox
              component="div"
              inputProps={{ "aria-labelledby": id }}
              checked={selected}
              onChange={(ev) => onChangeSelected(ev.target.checked)}
            />
          </TableCell>
        )}

        <TableOverflowCell>
          <ResourceDetails
            title={
              <NamespaceLink
                id={id}
                namespace={handler.namespace}
                to={`/handlers/${handler.name}`}
              >
                <strong>{handler.name} </strong>
              </NamespaceLink>
            }
            details={<HandlersListItemDetails handler={handler} />}
          />
        </TableOverflowCell>

        <FloatingTableToolbarCell
          hovered={hovered}
          disabled={!editable || editing}
        >
          {() => (
            <ToolbarMenu>
              <ToolbarMenu.Item key="edit" visible="never">
                <EditMenuItem onClick={onClickEdit} />
              </ToolbarMenu.Item>
              <ToolbarMenu.Item key="delete" visible="never">
                {(menu) => (
                  <ConfirmDelete
                    identifier={handler.name}
                    onSubmit={() => {
                      onClickDelete();
                      menu.close();
                    }}
                  >
                    {(dialog) => (
                      <DeleteMenuItem
                        autoClose={false}
                        title="Delete…"
                        onClick={dialog.open}
                      />
                    )}
                  </ConfirmDelete>
                )}
              </ToolbarMenu.Item>
            </ToolbarMenu>
          )}
        </FloatingTableToolbarCell>
      </TableSelectableRow>
    </HoverController>
  );
};

HandlersListItem.propTypes = {
  editable: PropTypes.bool,
  editing: PropTypes.bool,
  handler: PropTypes.object.isRequired,
  hovered: PropTypes.bool,
  onHover: PropTypes.func,
  selected: PropTypes.bool,
  onChangeSelected: PropTypes.func,
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func,
};

HandlersListItem.defaultProps = {
  editable: false,
  editing: false,
  hovered: false,
  onHover: () => null,
  selected: false,
  onChangeSelected: () => null,
  onClickEdit: () => null,
  onClickDelete: () => null,
};

HandlersListItem.fragments = {
  handler: gql`
    fragment HandlersListItem_handler on Handler {
      id
      name
      namespace
      command

      ...HandlersListItemDetails_handler
    }

    ${HandlersListItemDetails.fragments.handler}
  `,
};

export default HandlersListItem;
